import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { WorkspaceRedFlagListScreen } from '@/features/red-flags/components/workspace/RedFlagListScreen';
import { requirePermission } from '@/lib/guards';

const searchSchema = z.object({
  status: z.enum(['open', 'under_review', 'closed']).optional(),
});

export const Route = createFileRoute('/app/red-flags/')({
  validateSearch: (input) => searchSchema.parse(input),
  beforeLoad: () => {
    requirePermission('red_flag:read');
  },
  component: ClinicalRedFlagListRoute,
  staticData: { crumb: 'Red flags' },
});

function ClinicalRedFlagListRoute() {
  return <WorkspaceRedFlagListScreen surface="clinical" />;
}
